@import 'styles/variables';
@import 'styles/mixins';

.container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.tag {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px;
  background-color: var(--dark-3);
  border-radius: 6px;
  border: 1px solid var(--dark-4);
  color: var(--dark-80);

  svg {
    flex-shrink: 0;
  }
}

.changeHowAIUsed {
  margin-top: 8px;
}
